import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';

import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import Events from './pages/Events';
import EventDetail from './pages/EventDetail';
import EventRegister from './pages/EventRegister';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Mission from './pages/Mission';
import GetInspired from './pages/GetInspired';
import About from './pages/About';
import Contact from './pages/Contact';
import Account from './pages/Account';
import Login from './pages/Login';
import Register from './pages/Register';
import ProductVerification from './pages/ProductVerification';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Short stale window so the storefront reflects admin changes quickly.
      // Combined with refetch-on-focus, returning to a tab pulls fresh data.
      staleTime: 30 * 1000, // 30 seconds
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <ScrollToTop />
        <div className="min-h-screen bg-gray-50">
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/catalogue" element={<Shop />} />
              <Route path="/shop" element={<Navigate to="/catalogue" replace />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/events" element={<Events />} />
              <Route path="/events/:id/register" element={<EventRegister />} />
              <Route path="/events/:id" element={<EventDetail />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<BlogPost />} />
              <Route path="/mission" element={<Mission />} />
              <Route path="/inspired" element={<GetInspired />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/account" element={<Account />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
                  <Route path="/verify" element={<ProductVerification />} />
            </Routes>
          </Layout>
        </div>
      </Router>
      
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
        }}
      />
    </QueryClientProvider>
  );
}

export default App;
